@switch (context ? context.type : '') {
    @default {
        <fui-edit-image-input
            [control]="control" [disabled]="disabled" #input [label]="label" [(ngModel)]="value"
            [(imageOpacity)]="imageOpacity" (focussed$)="onFocussed($event)"
            [maxImageSize]="maxImageSize" [allowSvg]="allowSvg"
            [showImage]="showImage" [showOpacitySlider]="showOpacitySlider"
            [placeholder]="placeholder" [placeholderImage]="placeholderImage"></fui-edit-image-input>
    }
    @case (contextType.INLINE) {
        <fui-inline-image-input
            [control]="control" [disabled]="disabled" #input [label]="label" [(ngModel)]="value"
            [(imageOpacity)]="imageOpacity" (focussed$)="onFocussed($event)"
            [maxImageSize]="maxImageSize" [allowSvg]="allowSvg"
            [showImage]="showImage" [showOpacitySlider]="showOpacitySlider"
            [placeholder]="placeholder" [placeholderImage]="placeholderImage"></fui-inline-image-input>
    }
}
